export default {
  'Start at': 'प्रारंभ',
  'Set to current time': 'वर्तमान समय पर सेट करें',
  'Audio volume': 'ऑडियो वॉल्यूम',
  'Video volume': 'वीडियो वॉल्यूम',
  'Trim audio': 'ऑडियो ट्रिम करें',
  'Audio will end with the video': 'ऑडियो वीडियो के साथ समाप्त हो जाएगा।',
  'Trim': 'ट्रिम करें',
}